import React, { useState, useRef, useEffect } from 'react';

const PriorityDropdown = ({ value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const priorities = [
    { value: 'Low', color: '#B9B7AE' },
    { value: 'Medium', color: '#F4A340' },
    { value: 'High', color: '#E24B5B' },
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const currentPriority = priorities.find(p => p.value === value) || priorities[1];

  return (
    <div ref={dropdownRef} style={{ position: 'relative', width: '100%' }}>
      <button
        className="priority-pill"
        style={{ backgroundColor: currentPriority.color, color: '#ffffff', width: '100%' }}
        onClick={() => setIsOpen(!isOpen)}
        data-testid="priority-dropdown-button"
      >
        {currentPriority.value}
      </button>
      {isOpen && (
        <div className="dropdown" style={{ top: '100%', left: 0, marginTop: '4px' }}>
          {priorities.map((priority) => (
            <div
              key={priority.value}
              className="dropdown-item"
              onClick={() => {
                onChange(priority.value);
                setIsOpen(false);
              }}
              data-testid="priority-option"
            >
              <div
                style={{
                  width: '12px',
                  height: '12px',
                  borderRadius: '2px',
                  backgroundColor: priority.color
                }}
              ></div>
              <span>{priority.value}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PriorityDropdown;